import { createEntryPoint } from '#packages/apilib';
import { StudioMigrationManagerKey } from './publicApiKey';
import {
  StudioMigrationManagerApi,
  initializeStudioPremium,
} from './studioMigrationManagerApi';
import { StudioMigrationManagerScope } from './studioMigrationManagerScope';

export const StudioMigrationManagerEntryPoint = createEntryPoint({
  name: 'StudioMigrationManager',
  Scope: StudioMigrationManagerScope,
  publicApi({ contributeApi }) {
    contributeApi(StudioMigrationManagerKey, StudioMigrationManagerApi);
  },
  async initialize(scope: StudioMigrationManagerScope) {
    const { editorAPI, editorCoreAPI } = scope;

    await Promise.all([
      new Promise((resolve) => {
        editorAPI.registerInitUserPrefsCallback(resolve);
      }),
      editorCoreAPI.hooks.stageIsReadyAndVisible.promise,
    ]);

    void initializeStudioPremium(scope);
  },
});
